<template>
  <transition name="slide-fade">
    <div class="fs-wrapper" v-if="adData && visible">
      <div class="popup-ad-wrapper" :style="adSize">
        <img
          class="popup-ad"
          :src="adData.image"
          alt="广告"
          @click="goJumpToAd(adId, adData.url)"
          :style="adSize"
        />
        <img
          src="../../assets/img/common/close_panel_btn.png"
          class="close-btn"
          @click="closeAd"
          alt=""
        />
      </div>
    </div>
  </transition>
</template>
<script>
import { getBanner, setAdvertStats } from "../../api/ad_api";
import { onMounted, ref, watch, nextTick, reactive } from "vue";
import { DoOne } from "../../utils/OnedayFun";
// 弹窗广告
import usePublicize from "../../hooks/publicize/usePublicize";
import { debounce } from "lodash";

export default {
  name: "index-popup-publicize",
  props: {
    adId: {
      type: [String, Number],
      default: null,
    },
    size: {
      type: Object,
      default: () => {
        return {
          width: "1300px",
          height: "174px",
        };
      },
    },
  },
  setup(props) {
    let adData = ref(null);
    const adDatas = ref([]);
    const num = ref(0);
    const adSize = ref({});
    const visible = ref(false);
    const pid = ref(""); // 弹窗组的id
    const adState = reactive({
      pathStorage: "",
      isDayOrFirst: -1,
    });
    /**
     * 加载广告
     * @param id
     * @returns {Promise<void>}
     */
    const loadAd = async (id) => {
      const { data } = await getBanner(id);
      /*
       * 如果 首次登录（1） 展示所有数组
       * 如果 每日一次 只筛选出 配置为每日一次的
       * */
      switch (adState.isDayOrFirst) {
        case 1:
          adDatas.value = data;
          break;
        case 0:
          data.forEach((item, index) => {
            // show_frequency 首次登录 1  每日一次 0
            if (item.show_frequency != 1) {
              adDatas.value.push(item);
              return;
            }
          });
          break;
        default:
          break;
      }
      adData.value = adDatas.value[0];
      if (adData.value) {
        if (adData.value.width && adData.value.height) {
          pid.value = adData.value.pid;
          adSize.value.width = adData.value.width;
          adSize.value.height = adData.value.height;
        } else {
          adSize.value = props.size;
        }
        await showFlag();
      }
    };
    /**
     * 展示图片权限
     */
    const showFlag = async () => {
      if (adData.value) {
        visible.value = true;
        /**
         * 记录广告弹窗
         */
        if (adDatas.value[num.value]?.id) {
          await setAdvertStats({ id: adDatas.value[num.value].id, type: 1 });
        }
      } else {
        visible.value = false;
      }
    };
    /**
     * 关闭广告
     */
    const closeAd = debounce(async () => {
      num.value += 1;
      adData.value = adDatas.value[num.value];
      if (adData.value) {
        await setAdvertStats({ id: adDatas.value[num.value].id, type: 1 });
      }
      if (!adData.value) {
        flagSaveCache();
        // localStorage.firstLogin = 0;
        localStorage.removeItem("adNum");
      }
      localStorage.FirstLogin = "0";
      /** 弹窗广告 记录*/
      // await setAdvertStats({ id: adDatas.value[num.value - 1].id, type: 2 });
    }, 300);
    const flagSaveCache = () => {
      // this.isDayOrFirst === 1
      // ?
      localStorage[adState.pathStorage] = "0";
      // :
      DoOne(adState.pathStorage);

      setTimeout(() => {
        adState.isDayOrFirst = -1;
      }, 1000);
    };
    const { jumpToAd } = usePublicize();
    /**
     * 跳转广告链接
     */
    const goJumpToAd = debounce(async (id, url) => {
      flagSaveCache();
      await setAdvertStats({ id: adDatas.value[num.value].id, type: 2 });
      jumpToAd(id, url);
      localStorage.setItem("adNum", num.value++);

      setTimeout(() => {
        const adNum = localStorage.getItem("adNum");
        if (adDatas.value[parseInt(adNum) + 1]) {
          adData.value = adDatas.value[parseInt(adNum) + 1];
          visible.value = true;
        } else {
          DoOne(adState.pathStorage);
          localStorage.removeItem("adNum");
          visible.value = false;
          return;
        }
      }, 1000);
      visible.value = false;
    }, 300);
    /**
     * 获取当前localStroage所有key的值，组成数组
     * @param item
     */
    const getObjKeys = (item) => {
      return Object.keys(item);
    };

    /**
     * 整理字符串
     */
    const arrangeString = () => {
      /**
       * 当前页面 是否匹配首次访问
       */

      adState.pathStorage = `JY+${window.location.hash
        .slice(2)
        .replaceAll("/", "_")}`;
      /** localStroage 数组*/
      if (adState.pathStorage.indexOf("?") > -1) {
        const index = adState.pathStorage.indexOf("?");
        adState.pathStorage = adState.pathStorage.substring(0, index);
      }
      const storage = getObjKeys(localStorage.valueOf());
      if (storage.includes(adState.pathStorage)) {
        // if (storage.indexOf(adState.pathStorage) !== -1) {
        switch (localStorage.getItem(adState.pathStorage)) {
          case "1":
            adState.isDayOrFirst = 1;
            break;
          case "0":
            if (document.cookie.indexOf(`${adState.pathStorage}=1`) === -1) {
              adState.isDayOrFirst = 0;
            }
            break;
          default:
            adState.isDayOrFirst = -1;
            break;
        }
      }
    };
    /**
     * 页面数据加载完成
     * */
    // watch(
    //   () => adData.value,
    //   (nVal, oVal) => {
    //     console.log(nVal);
    //     if (nVal) {
    //       console.log(document.cookie);
    //       console.log(`${pid.value}=1`);
    //       if (document.cookie.indexOf(`${pid.value}=1`) === -1) {
    //         showFlag();
    //       }
    //     } else {
    //       DoOne(pid.value);
    //     }
    //   }
    // );

    /**
     * 生命周期
     * 初始化页面
     */
    onMounted(async () => {
      if (localStorage.access_token) {
        /**
         * 监听首页后退事件
         * 后退广告自动隐藏了
         */
        window.addEventListener(
          "popstate",
          function () {
            // DoOne(pid.value);
            visible.value = false;
            localStorage.removeItem("adNum");
          },
          false
        );
        arrangeString();
        const { adId } = props;
        /**
         * 广告弹窗接口
         */
        if (adId) await loadAd(adId);

        let adNum = localStorage.getItem("adNum");
        if (adNum) {
          num.value = parseInt(adNum) + 1;
        } else {
          num.value = 0;
        }
        adData.value = adDatas.value[num.value];
        await showFlag();
      }
    });
    return {
      goJumpToAd,
      adData,
      adSize,
      closeAd,
      DoOne,
      adState,
      visible,
      getObjKeys,
      arrangeString,
      flagSaveCache,
    };
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/animation.css";

.fs-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 998;

  .popup-ad-wrapper {
    margin: 10px auto;
    border-radius: 8px;
    position: relative;

    .close-btn {
      position: absolute;
      z-index: 1025;
      left: 50%;
      bottom: -50px;
      width: 40px;
      height: 40px;
      margin-left: -20px;
      cursor: pointer;
    }

    .popup-ad {
      object-fit: cover;
    }
  }
}
</style>
